module.exports = __webpack_public_path__ + "media/images/clickworker_com/2fa_step_3-5fb8da9936d042b1d9b5b960e0034e20.png";